import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import type { ITheme } from '@homeviews/styles'
import { UserManager } from '@homeviews/users'
import { WindowTitle } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
  }),
)

const Widgets: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <WindowTitle title="Create Company User" />
      <div className={classes.root}>
        <UserManager />
      </div>
    </>
  )
}

export default Widgets
